/* XMarket · "Agregar" de un clic para accesorios y sugerencias (11-10-2026).
   Cualquier botón con data-xm-add="<variant id>" agrega 1 unidad.
   - En la ficha y en la ventanita: usa la misma ventanita del tema (cart-notification)
     pidiendo sus secciones, igual que el botón de compra.
   - Con data-xm-reload (página del carrito): recarga para que el total se actualice.
   La página del carrito también pinta sugerencias desde JSON: ver renderSugerencias. */
(function () {
  "use strict";
  if (window.__xmUpsell) return;
  window.__xmUpsell = true;

  function money(cents) {
    return Math.round(cents / 100).toLocaleString("de-DE") + "Gs";
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function add(btn) {
    var id = btn.getAttribute("data-xm-add");
    if (!id || btn.getAttribute("aria-busy") === "true") return;
    var reload = btn.hasAttribute("data-xm-reload");
    var notif = document.querySelector("cart-notification");
    var fd = new FormData();
    fd.append("id", id);
    fd.append("quantity", "1");
    if (!reload && notif && typeof notif.getSectionsToRender === "function") {
      fd.append("sections", notif.getSectionsToRender().map(function (s) { return s.id; }).join(","));
      fd.append("sections_url", window.location.pathname);
    }
    var label = btn.textContent;
    btn.setAttribute("aria-busy", "true");
    btn.textContent = "Agregando…";
    fetch("/cart/add.js", { method: "POST", body: fd, headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          btn.textContent = "Sin stock";
          btn.removeAttribute("aria-busy");
          return;
        }
        btn.textContent = "Agregado ✓";
        btn.classList.add("is-added");
        if (reload) { window.location.reload(); return; }
        if (notif && typeof notif.renderContents === "function" && res.j.sections) {
          try { notif.renderContents(res.j); } catch (e) {}
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: "xm-upsell", productVariantId: id }); } catch (e) {}
        }
      })
      .catch(function () {
        btn.textContent = label;
        btn.removeAttribute("aria-busy");
      });
  }

  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-xm-add]");
    if (!b) return;
    e.preventDefault();
    add(b);
  });

  /* Sugerencias del carrito para lo que no es celular: productos relacionados al
     artículo principal (Shopify los calcula). Si falta plata para el envío gratis,
     primero los que cierran la diferencia. */
  function renderSugerencias(box) {
    var pid = box.getAttribute("data-producto");
    var gap = parseInt(box.getAttribute("data-falta") || "0", 10);
    var excl = (box.getAttribute("data-excluir") || "").split(",");
    var list = box.querySelector("[data-xm-lista]");
    if (!pid || !list) return;
    fetch("/recommendations/products.json?product_id=" + encodeURIComponent(pid) + "&limit=10&intent=related")
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var ps = (j.products || []).filter(function (p) {
          return p.available && excl.indexOf(String(p.id)) === -1 && p.variants && p.variants.length;
        });
        if (gap > 0) {
          ps.sort(function (a, b) {
            var ca = a.price >= gap ? 0 : 1, cb = b.price >= gap ? 0 : 1;
            return ca - cb || a.price - b.price;
          });
        }
        ps = ps.slice(0, 4);
        if (!ps.length) return;
        list.innerHTML = ps.map(function (p) {
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=160" : "";
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          return '<li class="xm-acc__item">' +
            '<a href="' + esc(p.url) + '" class="xm-acc__img" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : "") + "</a>" +
            '<div class="xm-acc__body"><a href="' + esc(p.url) + '" class="xm-acc__name">' + esc(p.title) + '</a><span class="xm-acc__price">' + money(p.price) + "</span></div>" +
            '<button type="button" class="xm-acc__add" data-xm-add="' + v.id + '" data-xm-reload aria-label="Agregar ' + esc(p.title) + ' al carrito">Agregar</button></li>';
        }).join("");
        box.hidden = false;
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll("[data-xm-sugerencias]").forEach(renderSugerencias);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
